import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonHLPure, CardInfo } from "../../pures";
import "./reliable-signature-description.css";

const ReliableSignatureDescriptionView = (props) => {
  const { t } = useTranslation();
  const { step, onHandleBack, onHandleNext } = props;
  const { next, back } = step;
  const [LlavePrivada, LlavePublic, certificado] = [
    "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_private_key.png",
    "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_public_key.png",
    "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_certificate.png",
  ];

  return (
    <div className="card-description-reliable">
      <div>
        <p className="p-principal">
          {t("signatures.download.view.description")}
        </p>
      </div>
      <div className="items">
        <CardInfo
          image={LlavePrivada}
          alt="Llave privada"
          title={t("signatures.download.view.privatekey")}
          content={t("signatures.download.view.privatekeyDescription")}
        />
        <CardInfo
          image={LlavePublic}
          alt="Llave publica"
          title={t("signatures.download.view.publickey")}
          content={t("signatures.download.view.publickeyDescription")}
        />
        <CardInfo
          image={certificado}
          alt="Certificado"
          title={t("signatures.download.view.certificate")}
          content={t("signatures.download.view.certificateDescription")}
        />
      </div>
      <div className="ReliableSignatureDescriptionView-action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={(event) => onHandleBack(event)}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={(event) => onHandleNext(event)}
        />
      </div>
    </div>
  );
};

export { ReliableSignatureDescriptionView as default };
